import RefreshImg from "public/migrationToMost/wpf_refresh-shield.svg";
import PeopleImg from "public/migrationToMost/fluent_people-team-20-filled.svg";
import serverImg from "public/migrationToMost/fa6-solid_server.svg";
import IntegrationImg from "public/migrationToMost/oui_integration-general.svg";

export const WHY_ONEMIND_CONSTANTS = [
  {
    image: IntegrationImg,
    title: "Seamless Migration with API Compatibility",
    text: "Use AWS-compatible APIs and automation tools to simplify and accelerate your EC2 workload transition.",
  },
  {
    image: RefreshImg,
    title: "Orchestrated Cutover with Xmost Automation",
    text: "Minimize downtime and human error with pipeline-driven deployment and validation workflows.",
  },
  {
    image: serverImg,
    title: "Tailored Storage & Compute Architecture",
    text: "Customize storage type, performance tier, and capacity to match your specific workload needs — from block to object.",
  },
  {
    image: PeopleImg,
    title: "Enterprise-Ready Security & Multi-Cloud Flexibility",
    text: "Enforce RBAC, encryption, and compliance standards while maintaining hybrid or multi-cloud interconnectivity.",
  },
];
